// Outside of state, because we only run once on load;
export default () => {
	if (typeof document === 'undefined') {
		return false;
	}
	const testCanvas = document.createElement('canvas');
	if (testCanvas.getContext && testCanvas.getContext('2d')) {
		return testCanvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
	}
	return false;
};



// WEBPACK FOOTER //
// ./scripts/sky-crop/factories/webpSupport.js